import { render, staticRenderFns } from "./StallCart.vue?vue&type=template&id=efea1426&scoped=true"
import script from "./StallCart.vue?vue&type=script&lang=js"
export * from "./StallCart.vue?vue&type=script&lang=js"
import style0 from "./StallCart.vue?vue&type=style&index=0&id=efea1426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efea1426",
  null
  
)

export default component.exports